import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Milestones from "@/components/site/Milestones";
import useSmoothScroll from "@/components/motion/useSmoothScroll";
import usePageMeta from "@/hooks/usePageMeta";
import Reveal from "@/components/motion/Reveal";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function HouseOfRudra() {
  useSmoothScroll();
  usePageMeta({
    title: "The House of Rudra | RUDRA EMPIRE",
    description:
      "The legacy of RUDRA EMPIRE — founded in 1995 by Sri Rudra Singh, presently chaired by Dr. Anurag Singh. A private business house dedicated to the strategic acquisition and consolidation of land in Karnataka.",
    canonical: "https://rudraempire.com/house-of-rudra",
  });
  return (
    <main className="relative bg-[#08080A] text-neutral-100">
      <Header />

      {/* Hero — full wordmark identity */}
      <section className="relative pt-40 md:pt-56 pb-20 border-b border-white/8">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Reveal>
            <Link to="/" className="link-gold inline-flex items-center gap-2 text-xs tracking-[0.24em] uppercase text-neutral-400 mb-10">
              <ArrowLeft className="w-4 h-4" /> Return Home
            </Link>
            <div className="overline mb-6">The House of Rudra</div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-neutral-50">
              Legacy · <span className="italic text-[#D4AF37]">Stewardship</span> · Continuity
            </h1>
          </Reveal>
          <Reveal delay={0.2} className="mt-10 md:mt-14 flex justify-center">
            <img src="/emblem.png" alt="Rudra Empire crest" className="w-full max-w-md h-auto" />
          </Reveal>
        </div>
      </section>

      {/* Founder + Dr. Swity + Second Generation */}
      <section className="py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 space-y-20">
          <Reveal>
            <div className="overline mb-4">The Founder</div>
            <h2 className="font-display text-4xl md:text-5xl text-neutral-50 mb-6">Rudra Singh</h2>
            <p className="text-neutral-300 leading-relaxed max-w-3xl">
              Rudra Singh moved to Delhi with his parents in 1982. He completed his B.Tech in Computer Science from IIT Delhi, cleared the Civil Services Examination and joined the Indian Police Service, subsequently resigning to pursue an entrepreneurial calling. In 1995 he founded RUDRA EMPIRE in Karnataka — a privately held business centred on the strategic acquisition and consolidation of land.
            </p>
          </Reveal>

          <Reveal>
            <div className="overline mb-4">Dr. Swity Singh</div>
            <h2 className="font-display text-4xl md:text-5xl text-neutral-50 mb-6">A Life in Medicine</h2>
            <p className="text-neutral-300 leading-relaxed max-w-3xl">
              Dr. Swity Singh was a Pediatric Neurosurgeon at AIIMS Delhi. She represents the intellectual and professional dimension of the family's early legacy and, together with the founder, shaped the values of discipline and precision that continue to inform the house.
            </p>
          </Reveal>

          <Reveal>
            <div className="overline mb-4">Second Generation</div>
            <h2 className="font-display text-4xl md:text-5xl text-neutral-50 mb-6">Dr. Anurag Singh</h2>
            <p className="text-neutral-300 leading-relaxed max-w-3xl">
              Following his father's passing in 2011, Anurag Singh assumed ownership of RUDRA EMPIRE. He continued his medical education — completing MBBS, MS in General Surgery and MCh in Cardiothoracic &amp; Vascular Surgery — while operational stewardship of the business was entrusted, under Power of Attorney, to Mr. Jasprit Singh, the founder's long-standing trustee. Today Dr. Anurag Singh serves as Chairman and Legal Owner, providing strategic oversight of RUDRA EMPIRE while material decisions remain under his direction.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Timeline */}
      <Milestones />

      <Footer />
    </main>
  );
}
